import AdminTaskContainer from "../containers/AdminTaskContainer";
import AdminTaskFormContainer from "../containers/AdminTaskFormContainer";
import { TasksProvider } from "../providers/TasksProvider";
import { Box, Stack } from "@chakra-ui/react";

export default function AdminPage({ user }) {
  return (
    <Box width={"full"} display={"flex"} flexDirection={{ base: "column", md: "column" }} justifyContent={"center"} p={{ base: 2, md: 4 }}>
      <TasksProvider user={user}>
        <Stack spacing={4} width={"full"} direction={{ base: "column", md: "column" }}>
          <AdminTaskContainer user={user} />
          <AdminTaskFormContainer user={user} />
        </Stack>
      </TasksProvider>
    </Box>
  );
}
